import { ArrowPressHandler } from "@noriginmedia/norigin-spatial-navigation";

import { ButtonProps, FocusButton } from "@/components";

import { FocusListRadioButton } from "./focus-list-radio-button";

type FocusListButtonProps = CommonProps &
  Pick<ButtonProps, "textAlign" | "active"> & {
    label: string;
    onEnterPress: () => void;
    focusKey?: string;
    isRadioButton?: boolean;
    onArrowPress?: ArrowPressHandler;
  };

export function FocusListButton(props: FocusListButtonProps): JSX.Element {
  if (props.isRadioButton) {
    return (
      <FocusListRadioButton
        text={props.label}
        onEnterPress={props.onEnterPress}
        focusKey={props.focusKey}
        textAlign={props.textAlign}
        active={props.active}
        block
        short
        variant="ghost"
        data-testid={props["data-testid"]}
        className={props.className}
        onArrowPress={props.onArrowPress}
        scrollOnFocus
      />
    );
  }
  return (
    <FocusButton
      text={props.label}
      onEnterPress={props.onEnterPress}
      focusKey={props.focusKey}
      textAlign={props.textAlign}
      active={props.active}
      block
      short
      variant="ghost"
      data-testid={props["data-testid"]}
      className={props.className}
      onArrowPress={props.onArrowPress}
      scrollOnFocus
    />
  );
}
